export default function ({ id, negativeRating, positiveRating }) {
    return {
        actionsIsDisabled: false,
        positiveRating: positiveRating,
        negativeRating: negativeRating,
        errors: [],
        readMore: false,
        init() {
            this.actionsIsDisabled = this.getVoteFromLocalStorage(id);
        },
        getVoteFromLocalStorage(id) {
            const data = window.localStorage.getItem('question-vote');
            if (data) {
                const faqId = JSON.parse(data);
                return !!faqId.find((item) => item.id === id);
            }
            return false;
        },
        setVoteToLocalStorage(id) {
            const data = window.localStorage.getItem('question-vote');
            let mergeData = data ? JSON.parse(data) : [];

            const voteIndex = mergeData.findIndex((item) => item.id === id);
            if (voteIndex === -1) {
                mergeData.push({ id });
            }

            window.localStorage.setItem(
                'question-vote',
                JSON.stringify(mergeData)
            );
        },
        errorMessage(message) {
            let time = null;
            this.errors.push(message);
            clearInterval(time);
            time = setTimeout(() => {
                this.errors = [];
            }, 3000);
        },
        setVote(isPositiveVoted) {
            if (isPositiveVoted) {
                this.positiveRating++;
            } else {
                this.negativeRating++;
            }
        },
        votePositiveOrNegative(isPositiveVoted = false) {
            this.actionsIsDisabled = true;

            let bodyData = {
                id: id,
                positive: isPositiveVoted ? 1 : 0,
                isPositiveVoted,
                votingBehavior: 'yesno',
                isAjax: true,
                form_key: document.querySelector('input[name="form_key"]').value
            };

            try {
                fetch(`${window.BASE_URL}faq/index/vote`, {
                    method: 'POST',
                    body: new URLSearchParams(bodyData)
                })
                    .then((response) => response.json())
                    .then((response) => {
                        if (response.result.code === 'success') {
                            this.setVote(isPositiveVoted);
                            this.setVoteToLocalStorage(id);
                        } else {
                            this.errorMessage(response.result.message);
                        }
                    })
                    .catch((error) => {
                        this.actionsIsDisabled = false;
                        console.error(error);
                    });
            } catch (error) {
                console.log(error);
                console.error(error);
            }
        },
        voteRenderText(vote) {
            return `(${vote})`;
        }
    };
}
